import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  connect() {
    // this.updateSize()
    this.element.addEventListener('input', () => this.updateSize())
    this.updateSize()
  }

  updateSize() {
    this.element.parentNode.dataset.replicatedValue = this.element.value
  }
}
